export default __webpack_public_path__ + "static/media/buttons-field-type.0eeaafa1.svg";